import React, { Component } from 'react';
import {cleanPath} from '../../Utils.js';
import {t} from "../../lang/i18n.js";
import {NavLink, Link} from "react-router-dom";

import './Footer.scss';

export class Footer extends Component {

  constructor(props) {
    super(props);
    this.state = { data: {}, type: 0 };
  }

  componentDidMount() {
    let currentSlug = this.props.location.pathname;
    let type = (currentSlug.includes('about') || currentSlug.includes('profile')) ? 1 : (currentSlug.includes('work') && !currentSlug.endsWith('work/')) ? 2 : 0;
    this.setState({type : type});
  }

  componentDidUpdate(prevProps, prevState) {
    const locationChanged = prevProps.location.pathname !== this.props.location.pathname;
    if (locationChanged) {
      let currentSlug = this.props.location.pathname;
      let type = (currentSlug.includes('about') || currentSlug.includes('profile')) ? 1 : (currentSlug.includes('work') && !currentSlug.endsWith('work/')) ? 2 : 0;
      this.setState({type : type});
    }
  }

  renderMenu() {
    if (this.props.menu) {
      const menuItemsArray = Object.values(this.props.menu)

      return (
        <ul>
          {Object.values(menuItemsArray).map((item, index) => {
          let target = item.target;

          if (target === '_blank') {
            return (
              <li key={index} index={index}>
                <a href={item.url} target="_blank" rel="noreferrer noopener">{item.title}</a>
              </li>
            )
          } else {
            let link = cleanPath(item.url)

            return (
              <li key={index} index={index}>
                <NavLink to={link} activeClassName="selected" onClick={this._toggleMenu}>{item.title}</NavLink>
              </li>
            )
          }

          })
        }
        </ul>

      )
    }
  }



  render() {
      let options = this.props.options;
      let contactEmail = options.contact_email;
      let contactPhone = options.contact_phone;
      let contactSkype = options.contact_skype;
      let contactFacebook = options.contact_facebook;
      let contactTwitter = options.contact_twitter;
      let contactInstagram = options.contact_instagram;
      let contactBehance = options.contact_behance;
      let contactVimeo = options.contact_vimeo;
      let basedin = options.based_in_large;
      let press = options.press_content;
      let type = this.state.type;

      if (type === 2 ) {
        return false;
      }
      return (

        <footer id="footer" className="site__footer">
          <div className="site__footer__inner">
          {type === 0 &&
            <div className="site__footer__section site__footer__section--contact">
              <div className="site__footer__section__inner">
                <div className="site__footer__contact">
                  <h6 className="title title--2">{t('footerClaim')}</h6>
                  {contactEmail &&
                    <a className="subtitle" href={`mailto:${contactEmail}`} target="_blank" rel="noreferrer noopener">{contactEmail}</a>
                  }
                </div>
              </div>
            </div>
          }
          {type === 1 &&
            <div className="site__footer__section site__footer__section--about">
              <div className="site__footer__section__inner">
                {press &&
                  <div className="site__footer__press">
                    <h6 className="title title--4">{t('press')}</h6>
                    <div className="htmlcontent" dangerouslySetInnerHTML={{__html: press}}></div>
                  </div>
                }

                <div className="site__footer__contact">
                  <h6 className="title title--4">{t('contact')}</h6>
                  <ul>
                    {contactEmail &&
                      <li><a href={`mailto:${contactEmail}`} target="_blank" rel="noreferrer noopener">{contactEmail}</a></li>
                    }
                    {contactPhone &&
                      <li><a href={`tel:${contactPhone}`} target="_blank" rel="noreferrer noopener">{contactPhone}</a></li>

                    }
                    {contactSkype &&
                      <li><a href={`skype:${contactSkype}?chat`} target="_blank" rel="noreferrer noopener">{t('skype')}: {contactSkype}</a></li>
                    }
                  </ul>
                  {basedin &&
                    <p>{basedin}</p>
                  }
                </div>
              </div>
            </div>
          }

            <div className="site__footer__section site__footer__section--bottom">
              <div className="site__footer__section__inner">
                <div className="site__footer__social">
                  <ul>
                  {contactVimeo &&
                    <li>
                      <a href={contactVimeo} target="_blank" rel="noopener noreferrer">{t('vimeo')}</a>
                    </li>
                  }

                  {contactInstagram &&
                    <li>
                      <a href={contactInstagram} target="_blank" rel="noopener noreferrer">{t('instagram')}</a>
                    </li>
                  }

                  {contactBehance &&
                    <li>
                      <a href={contactBehance} target="_blank" rel="noopener noreferrer">{t('behance')}</a>
                    </li>
                  }
                  {contactTwitter &&
                    <li>
                      <a href={contactTwitter} target="_blank" rel="noopener noreferrer">{t('twitter')}</a>
                    </li>
                  }
                  {contactFacebook &&
                    <li>
                      <a href={contactFacebook} target="_blank" rel="noopener noreferrer">{t('facebook')}</a>
                    </li>
                  }
                  </ul>

                </div>

                <div className="site__footer__navigation">
                  {this.renderMenu()}

                </div>
                <div className="site__footer__copy">
                  <div>&copy; <span>{this.props.sitename}</span>, {new Date().getFullYear()}</div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      )
  }
}
